import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import App from "./App";
import RequireAuth from "./components/RequireAuth";
import Home from "./pages/Home";
import Pricing from "./pages/Pricing";
import ProjectPage from "./pages/Project";
import SourcesPage from "./pages/Sources";
import GeneratePage from "./pages/Generate";
import ReviewPage from "./pages/Review";
import ExportPage from "./pages/Export";
import NotFound from "./pages/NotFound";
import "./styles.css";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Home /> },
      { path: "pricing", element: <Pricing /> },
      {
        element: <RequireAuth />,
        children: [
          { path: "projects/:projectId", element: <ProjectPage /> },
          { path: "projects/:projectId/sources", element: <SourcesPage /> },
          { path: "projects/:projectId/generate", element: <GeneratePage /> },
          { path: "projects/:projectId/review", element: <ReviewPage /> },
          { path: "projects/:projectId/export", element: <ExportPage /> },
        ],
      },
      { path: "*", element: <NotFound /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
